import React, { useEffect } from 'react';
import { jsx, Grid, Box, Link, Flex, Text } from 'theme-ui';
import Marquee3k from 'marquee3000';

function Mean(props) {
	const { children } = props;
	useEffect(() => {
		Marquee3k.init();
	});
	return (
		<div className="marquee3k" data-speed="1.2" data-reverse="true" data-pausable="false">
			<Text
				as="span"
				sx={{
					fontSize: 'fs1',
					mx: 'm',
					my: 's',
					textAlign: 'center',
					fontFamily: 'sans'
				}}
				className="tsf xas"
			>
				{children}
			</Text>
		</div>
	);
}
export default Mean;
